var map = {
	"./businessServices/account.svg": "de05",
	"./businessServices/creditBook.svg": "17f6",
	"./businessServices/customers.svg": "74f9",
	"./businessServices/insights.svg": "52c4",
	"./businessServices/invoices.svg": "65ff",
	"./businessServices/loans.svg": "f054",
	"./businessServices/sales.svg": "a9a3",
	"./businessServices/tickets.svg": "c5b2",
	"./businessServices/transactions.svg": "e181",
	"./businessServices/wallet.svg": "e278",
	"./onlineStore/onlineCatalog.svg": "909e",
	"./onlineStore/onlineOrders.svg": "1062",
	"./profile/businessProfile.svg": "cf02",
	"./profile/manageUsers.svg": "e48b",
	"./retailStore/inventoryManagement.svg": "55ae",
	"./retailStore/myProducts.svg": "250c",
	"./retailStore/pointOfSale.svg": "40f2",
	"./retailStore/printLabel.svg": "a51f",
	"./retailStore/registers.svg": "4b12",
	"./settings/hardwareSettings.svg": "3cd3",
	"./settings/notificationSettings.svg": "629d",
	"./settings/settlementSettings.svg": "4a0f",
	"./settings/syncing.svg": "eb32",
	"./settings/wallet.svg": "f681",
	"./support/aboutUs.svg": "3d63",
	"./support/customerCare.svg": "f03e",
	"./support/terms.svg": "994a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5753";